'use client';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';

import { getPaymentMethods } from '@/app/(users)/[locationId]/(dashboard)/(store)/orders/actions/get-payment-methods';

export const usePaymentMethods = ({ locationIdFallback }: { locationIdFallback?: string } = {}) => {
  const { locationId } = useParams<{ locationId: string }>();

  return useQuery({
    queryKey: ['payment-methods', locationIdFallback ?? locationId],
    queryFn: () => getPaymentMethods(locationIdFallback ?? locationId ?? ''),
  });
};
